import { useEffect, useState } from "react";
import { getIssueCount, getIssues } from "../../services/ api_services";
import { isEmpty, isEqual } from "lodash";
import { Listbox, ListboxButton, ListboxOption, ListboxOptions, Transition } from "@headlessui/react";
import { ChevronUpDownIcon, CheckIcon, DocumentPlusIcon, MagnifyingGlassIcon } from "@heroicons/react/24/solid";
import { useNavigate } from "react-router-dom";
import { RxReload } from "react-icons/rx";
import axios from "axios";
import Pagination from "../../components/Pagination";
import SelectMenu from "../../components/SelectMenu";

const Issue = () => {
    const navigate = useNavigate();

    const stateType = [
        { name: "선택하세요", value: "n" },
        { name: "등록", value: "1" },
        { name: "검토중", value: "2" },
        { name: "검토완료", value: "3" },
        { name: "보류", value: "4" },
        { name: "완료", value: "5" },
    ];
    const issueType = [
        { name: "선택하세요", value: "n" },
        { name: "오류", value: "1" },
        { name: "개선요청", value: "2" },
        { name: "문의", value: "3" },
    ];
    const gubunType = [
        { name: "선택하세요", value: "n" },
        { name: "관리자 페이지", value: "1" },
        { name: "홈페이지", value: "2" },
        { name: "모바일", value: "3" },
    ];
    const priorityType = [
        { name: "선택하세요", value: "n" },
        { name: "높음(긴급)", value: "1" },
        { name: "보통", value: "2" },
        { name: "낮음", value: "3" },
    ];

    function classNames(...classes) {
        return classes.filter(Boolean).join(" ");
    }
    const pageSizes = [20, 50, 100];

    const initialCond = {
        subject: "",
        re_name: "",
        in_name: "",
        reg_date_start: "",
        reg_date_end: "",
        end_date_start: "",
        end_date_end: "",
    };

    const [list, setList] = useState([]);
    // const [key, setKey] = useState(0);
    const [cond, setCond] = useState(initialCond);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [pageSize, setPageSize] = useState(pageSizes[0]);
    // const [expanded, setExpanded] = useState(false);
    const [selectedState, setSelectedState] = useState(stateType[0]);
    const [selectedIssue, setSelectedIssue] = useState(issueType[0]);
    const [selectedGubun, setSelectedGubun] = useState(gubunType[0]);
    const [selectedPrior, setSelectedPrior] = useState(priorityType[0]);

    const onSearch = async () => {
        const data = {
            page_number: currentPage,
            page_size: pageSize,
            state: selectedState.value,
            issuet: selectedIssue.value,
            gubun: selectedGubun.value,
            priority: selectedPrior.value,
            subject: cond.subject,
            re_name: cond.re_name,
            in_name: cond.in_name,
            reg_date_start: cond.reg_date_start,
            reg_date_end: cond.reg_date_end,
            end_date_start: cond.end_date_start,
            end_date_end: cond.end_date_end,
        };

        await fetchIssue(data);
        await fetchIssueCount(data);
    };

    const resetdata = async () => {
        setSelectedState(stateType[0]);
        setSelectedIssue(issueType[0]);
        setSelectedGubun(gubunType[0]);
        setSelectedPrior(priorityType[0]);
        setCond((prevState) => {
            return {
                ...prevState,
                subject: "",
                re_name: "",
                in_name: "",
                reg_date_start: "",
                reg_date_end: "",
                end_date_start: "",
                end_date_end: "",
            };
        });
    };

    useEffect(() => {
        console.log("currentPage", currentPage);
        onSearch();
    }, [currentPage, pageSize]);

    const listclick = async (seq) => {
        navigate("/ad/addIssue/?id=" + seq);
    };

    /**
     *  총 리스트 카운트 가져오기
     */
    const fetchIssueCount = async (data) => {
        try {
            console.log("🚀 ~ fetchIssueCount ~ data:", data);
            const response = await getIssueCount(data);
            console.log("🚀 ~ fetchIssueCount ~ response:", response);
            if (response && response.status === 200) {
                setTotalCount(response.data);
            } else {
                setTotalCount(0);
            }
        } catch (e) {
            if (axios.isCancel(e)) {
                //console.log("요청이 취소되었습니다:", e.message);
            } else {
                console.error("Error fetching data: ", e);
            }
        }
    };

    const fetchIssue = async (data) => {
        const responseList = await getIssues(data);
        console.log("🚀 ~ fetchIssue ~ responseList:", responseList);
        if (responseList && responseList.status === 200 && !isEmpty(responseList.data)) {
            console.log("🚀 ~ fetchIssue ~ responseList.data:", responseList.data);
            responseList.data.map((item) => {
                item.issue.reg_date = formatDate(item.issue.reg_date);
                item.issue.end_date = formatDate(item.issue.end_date);
                return item;
            });
            console.log("🚀 ~ responseList.data.map ~ responseList.data:", responseList.data);
            setList(responseList.data);
        } else {
            setList([]);
        }
    };

    // 날짜 재구성
    function formatDate(dateString) {
        // console.log("🚀 ~ formatDate ~ dateString:", dateString);
        if (!dateString) return;
        const options = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            // second: "2-digit",
            hour12: false,
        };
        const date = new Date(dateString);
        return new Intl.DateTimeFormat("en-US", options).format(date).replace(/(\d{2})\/(\d{2})\/(\d{4}),/, "$3-$1-$2");
    }

    const handleOnSelectPageSize = (pageSize) => {
        console.log("🚀 ~ handleOnSelectPageSize ~ pageSize:", pageSize);
        // console.log("🚀 ~ handleOnSelectPageSize ~ pageSize:", Number(pageSize));
        setPageSize(Number(pageSize));
    };

    //'진행상태' selectbox
    const statedropdownType = () => {
        return (
            <Listbox value={selectedState} onChange={setSelectedState}>
                <div className="lg:w-44 sm:w-5/6 relative">
                    <ListboxButton className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600 sm:text-sm sm:leading-6">
                        <span className="block truncate">{selectedState.name}</span>
                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                            <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                        </span>
                    </ListboxButton>

                    <ListboxOptions
                        transition
                        className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                    >
                        {stateType.map((type, index) => (
                            <ListboxOption
                                key={index}
                                className="group relative cursor-default select-none py-2 pl-3 pr-4 text-gray-900 data-[focus]:bg-blue-600 data-[focus]:text-white"
                                value={type}
                            >
                                <span
                                    className={classNames(
                                        isEqual(type, selectedState) ? "font-semibold" : "",
                                        "block truncate font-normal group-data-[focus]:font-semibold"
                                    )}
                                >
                                    {type.name}
                                </span>
                                {isEqual(selectedState, type) && (
                                    <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-blue-600  group-data-[focus]:text-white ">
                                        <CheckIcon aria-hidden="true" className="h-5 w-5" />
                                    </span>
                                )}
                            </ListboxOption>
                        ))}
                    </ListboxOptions>
                </div>
            </Listbox>
        );
    };
    //'이슈타입' selectbox
    const issuedropdownType = () => {
        return (
            <div className="lg:w-44 sm:w-5/6 relative">
                <SelectMenu options={issueType} onSelect={setSelectedIssue} selectedId={selectedIssue.value} />
            </div>
        );
    };
    //'구분' selectbox
    const gubundropdownType = () => {
        return (
            <div className="lg:w-44 sm:w-5/6 relative">
                <SelectMenu options={gubunType} onSelect={setSelectedGubun} selectedId={selectedGubun.value} />
            </div>
        );
    };
    //'긴급도' selectbox
    const prioritydropdownType = () => {
        return (
            <div className="lg:w-44 sm:w-5/6 relative">
                <SelectMenu options={priorityType} onSelect={setSelectedPrior} selectedId={selectedPrior.value} />
            </div>
        );
    };

    return (
        <div>
            <span className="flex text-center justify-center align-middle text-nowrap text-gray-800 font-semibold text-2xl">
                이슈 게시판
            </span>
            <div className=" bg-gray-900 max-w-full mt-6 h-max ">
                <div className="mx-auto max-w-full">
                    <div className="bg-gray-900 pt-10 pb-2">
                        <div className="px-4 sm:px-6 lg:px-8">
                            {/* 조건 검색 */}
                            <div>
                                <div className="mt-5 px-3 py-2 ">
                                    <div className="w-full text-start text-sm font-light text-white">
                                        <div className="lg:flex flex-wrap justify-between items-cente">
                                            <div className="">
                                                <div className="flex items-center py-1">
                                                    <div className="text-end w-20 sm:w-20 pr-3">구분</div> {gubundropdownType()}
                                                </div>
                                            </div>
                                            <div className="">
                                                <div className="flex items-center py-1">
                                                    <div className="text-end w-20 sm:w-20 pr-3">이슈타입</div> {issuedropdownType()}
                                                </div>
                                            </div>
                                            <div className="">
                                                <div className="flex items-center py-1">
                                                    <div className="text-end w-20 sm:w-20 pr-3">긴급도</div> {prioritydropdownType()}
                                                </div>
                                            </div>
                                            <div className="">
                                                <div className="flex items-center py-1">
                                                    <div className="text-end w-20 sm:w-20 pr-3">진행상태</div> {statedropdownType()}
                                                </div>
                                            </div>
                                            <div className="">
                                                <div className="flex items-center py-1">
                                                    <div className="text-end w-20 sm:w-20 pr-3">검토자</div>
                                                    <input
                                                        type="search"
                                                        value={cond.in_name}
                                                        className="lg:w-56 sm:w-5/6 rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 text-sm"
                                                        onChange={(e) => {
                                                            setCond((prevState) => {
                                                                return { ...prevState, in_name: e.target.value.trim() };
                                                            });
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="lg:flex flex-wrap justify-between items-cente">
                                            <div className="lg:flex flex-wrap">
                                                <div className="flex items-center py-1">
                                                    {" "}
                                                    <div className="flex justify-end w-20 sm:w-20 pr-3">완료일</div>
                                                    <input
                                                        type="date"
                                                        className="w-32 form-input border bg-gray-50 border-gray-300 text-gray-900 focus:border-purple-500 text-sm pl-4 rounded-lg"
                                                        value={cond.end_date_start}
                                                        onChange={(e) => {
                                                            setCond((preVal) => {
                                                                return {
                                                                    ...preVal,
                                                                    end_date_start: e.target.value,
                                                                };
                                                            });
                                                        }}
                                                    />
                                                    <div className="px-2"> ~ </div>
                                                    <input
                                                        type="date"
                                                        min={cond.end_date_start}
                                                        value={cond.end_date_end}
                                                        onChange={(e) => {
                                                            setCond((preVal) => {
                                                                return {
                                                                    ...preVal,
                                                                    end_date_end: e.target.value,
                                                                };
                                                            });
                                                        }}
                                                        className="w-32 lg:mr-9 form-input border bg-gray-50 border-gray-300 text-gray-900 focus:border-purple-500 text-sm pl-4 rounded-lg"
                                                    />
                                                </div>
                                                <div className="flex items-center py-1">
                                                    <div className="flex justify-end w-20 sm:w-20 pr-3">등록일</div>
                                                    <input
                                                        type="date"
                                                        className="w-32 form-input border bg-gray-50 border-gray-300 text-gray-900 focus:border-purple-500  text-sm pl-4 rounded-lg"
                                                        value={cond.reg_date_start}
                                                        onChange={(e) => {
                                                            console.log("e.target.value ==>", e.target.value);
                                                            setCond((preVal) => {
                                                                return {
                                                                    ...preVal,
                                                                    reg_date_start: e.target.value,
                                                                };
                                                            });
                                                        }}
                                                    />
                                                    <div className="px-2"> ~ </div>
                                                    <input
                                                        type="date"
                                                        min={cond.reg_date_start}
                                                        className="w-32 form-input border bg-gray-50 border-gray-300 text-gray-900 focus:border-purple-500  text-sm pl-4 rounded-lg"
                                                        value={cond.reg_date_end}
                                                        onChange={(e) => {
                                                            setCond((preVal) => {
                                                                return {
                                                                    ...preVal,
                                                                    reg_date_end: e.target.value,
                                                                };
                                                            });
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="">
                                                <div className="flex items-center ">
                                                    <div className="flex justify-end w-20 sm:w-20 pr-3">제목</div>
                                                    <input
                                                        type="search"
                                                        value={cond.subject}
                                                        className="lg:w-64 sm:w-5/6 rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 text-sm"
                                                        //입력 창
                                                        onChange={(e) => {
                                                            setCond((prevState) => {
                                                                return { ...prevState, subject: e.target.value.trim() };
                                                            });
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <div className="">
                                                <div className="flex items-center">
                                                    <div className="flex justify-end w-20 sm:w-20 pr-3">등록자</div>
                                                    <input
                                                        type="search"
                                                        className="lg:w-56 sm:w-5/6 rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 text-sm"
                                                        value={cond.re_name}
                                                        onChange={(e) => {
                                                            setCond((prevState) => {
                                                                return { ...prevState, re_name: e.target.value.trim() };
                                                            });
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* 버튼 */}
                                    <div className="lg:flex justify-between items-center mt-4 mb-1">
                                        <div className="items-center grid justify-item-center my-2">
                                            <button
                                                type="button"
                                                className="flex justify-center items-center gap-x-1.5 rounded-md bg-lime-500 px-5 py-2 text-center text-sm font-semibold text-white hover:bg-lime-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500"
                                                onClick={() => {
                                                    navigate("/ad/addIssue");
                                                }}
                                            >
                                                <DocumentPlusIcon className="-ml-0.5 h-5 w-5" aria-hidden="true" />
                                                이슈등록
                                            </button>
                                        </div>
                                        <div className="lg:flex justify-end items-center ">
                                            <div className="lg:w-20 sm:w-full lg:mx-2 my-2">
                                                <button
                                                    type="button"
                                                    className="inline-flex justify-center items-center rounded-md w-full py-2 text-sm font-semibold text-white shadow-sm ring-1 ring-inset ring-gray-400 hover:bg-gray-700 "
                                                    onClick={() => {
                                                        resetdata();
                                                    }}
                                                >
                                                    <RxReload className="-ml-0.5 mr-1 h-4 w-4" />
                                                    초기화
                                                </button>
                                            </div>
                                            <div className="lg:w-40 sm:w-full lg:pr-2 my-2">
                                                <button
                                                    type="button"
                                                    className="inline-flex justify-center items-center rounded-md bg-indigo-600 w-full py-2 text-sm font-semibold text-white shadow-sm ring-1 ring-inset ring-indigo-600 hover:bg-indigo-500 "
                                                    onClick={() => {
                                                        onSearch();
                                                    }}
                                                >
                                                    <MagnifyingGlassIcon className="-ml-0.5 mr-1 h-5 w-5" aria-hidden="true" />
                                                    조회
                                                </button>
                                            </div>

                                            <label className="w-20 pr-2 items-center text-end text-sm font-medium text-white">
                                                조회 개수{" "}
                                            </label>
                                            <select
                                                className="rounded-md border-0 my-1 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                defaultValue={pageSizes && pageSizes[0]}
                                                onChange={(e) => handleOnSelectPageSize(e.target.value)}
                                            >
                                                {pageSizes.map((item) => {
                                                    return <option>{item}</option>;
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* 리스트 영역 */}
                            <div className="mt-4 flow-root">
                                <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                    <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                                        <table className="min-w-full divide-y divide-gray-700">
                                            <thead>
                                                <tr>
                                                    <th
                                                        scope="col"
                                                        className="py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-white sm:pl-0"
                                                    >
                                                        NO
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-white">
                                                        구분
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-white">
                                                        이슈타입
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-white">
                                                        긴급도
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-white">
                                                        진행상태
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-white">
                                                        제목
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-white">
                                                        등록일
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-white">
                                                        등록자
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-white">
                                                        검토자
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-white">
                                                        검토 결과
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-white">
                                                        완료일
                                                    </th>
                                                    {/* <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-white">
                                                        사용여부
                                                    </th> */}
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-800">
                                                {list &&
                                                    list.map((item, index) => {
                                                        {
                                                            return (
                                                                <tr
                                                                    key={index}
                                                                    onClick={() => {
                                                                        listclick(item.issue.seq);
                                                                    }}
                                                                    className="hover:bg-slate-800"
                                                                >
                                                                    <td className="whitespace-nowrap py-4 text-center px-4 pr-3 text-sm font-medium text-white sm:pl-0">
                                                                        {pageSize * currentPage + (index + 1) - pageSize}
                                                                    </td>
                                                                    <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-300">
                                                                        {item.issue.gubunType === "1"
                                                                            ? "관리자 페이지"
                                                                            : item.issue.gubunType === "2"
                                                                            ? "홈페이지"
                                                                            : item.issue.gubunType === "3"
                                                                            ? "모바일"
                                                                            : null}
                                                                    </td>
                                                                    <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-300">
                                                                        {item.issue.issueType === "1"
                                                                            ? "오류"
                                                                            : item.issue.issueType === "2"
                                                                            ? "개선요청"
                                                                            : item.issue.issueType === "3"
                                                                            ? "문의"
                                                                            : null}
                                                                    </td>
                                                                    <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-300">
                                                                        {item.issue.priorityType === "1"
                                                                            ? "높음(긴급)"
                                                                            : item.issue.priorityType === "2"
                                                                            ? "보통"
                                                                            : item.issue.priorityType === "3"
                                                                            ? "낮음"
                                                                            : null}
                                                                    </td>
                                                                    <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-300">
                                                                        {item.issue.stateType === "1"
                                                                            ? "등록"
                                                                            : item.issue.stateType === "2"
                                                                            ? "검토중"
                                                                            : item.issue.stateType === "3"
                                                                            ? "검토완료"
                                                                            : item.issue.stateType === "4"
                                                                            ? "보류"
                                                                            : item.issue.stateType === "5"
                                                                            ? "완료"
                                                                            : null}
                                                                    </td>
                                                                    <td className="whitespace-nowrap px-3 py-4 ">
                                                                        <input
                                                                            type="text"
                                                                            size="15"
                                                                            value={item.issue.subject}
                                                                            className="w-full truncate bg-inherit border-none focus:ring-gray-800 text-center text-sm text-gray-300"
                                                                            readOnly
                                                                        />
                                                                    </td>
                                                                    <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-300">
                                                                        {item.issue.reg_date}
                                                                    </td>
                                                                    <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-300">
                                                                        {item.admin_nm}
                                                                    </td>
                                                                    <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-300">
                                                                        {item.issue.in_name}
                                                                    </td>
                                                                    <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-300">
                                                                        <input
                                                                            type="text"
                                                                            size="9"
                                                                            value={item.issue.re_content}
                                                                            className="w-full truncate bg-inherit border-none focus:ring-gray-800 text-center text-sm text-gray-300"
                                                                            readOnly
                                                                        />
                                                                    </td>
                                                                    <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-300">
                                                                        {item.issue.end_date}
                                                                    </td>
                                                                    {/* <td className="whitespace-nowrap px-3 text-center py-4 text-sm text-gray-300">
                                                                        {item.issue.useYn === "Y" ? "사용" : "미사용"}
                                                                    </td> */}
                                                                </tr>
                                                            );
                                                        }
                                                    })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Pagination
                onChangeCurrentPage={(val) => setCurrentPage(val)}
                onChangeTotalPages={(val) => setTotalPages(val)}
                totalCount={totalCount}
                itemsPerPage={pageSize}
                // onPageChange={handleOnPageChange}
            />
        </div>
    );
};

export default Issue;
